import { Api, Codes } from '../api';
import { USER_TYPES } from '../constants/role';
import Permission from './permission';
import { Message } from 'element-ui';
import Login from './login';
import store from '../store';
import { ROLES } from '../constants/role';
class Teacher {
  constructor() {
    this.$login = Login;
    this.$permission = Permission;
    this.$message = Message;
    this.store = store;
    this.infoPromise;
  }
  get infoData() {
    return store.state.teacherLoginData;
  }
  get USER_TYPES() {
    return USER_TYPES;
  }
  get isLogin() {
    return this.$login.prototype.isTeacherLogin();
  }
  get name() {
    return this.infoData?.name || '';
  }
  /**
   * Admin：`is_admin` 或账号名以 `admin@` 开头（不含 staff）。
   * @returns {boolean}
   */
  get isAdmin() {
    return !!this.infoData?.is_admin || /^admin@/i.test(this.name);
  }
  get type() {
    return this.infoData?.type || 0;
  }
  get isTF() {
    return this.type === this.USER_TYPES.TF;
  }
  get isCSL() {
    return this.type === this.USER_TYPES.CSL;
  }
  /**
   * Staff：`type === STAFF`，或兼容旧账号名以 `staff@` 开头。
   * @returns {boolean}
   */
  get isStaff() {
    return this.type === this.USER_TYPES.STAFF || /^staff@/i.test(this.name);
  }
  getInfo() {
    if (this.infoPromise) {
      return this.infoPromise;
    } else if (this.infoData && Object.keys(this.infoData).length) {
      return new Promise(resolve => {
        resolve(this.infoData);
      });
    } else {
      return (this.infoPromise = new Promise((resolve, reject) => {
        Api.get.getTeacherInfo().then(res => {
          this.infoPromise = null;
          if (res.status === Codes.SUCCESS) {
            let data = res.data;
            this.store.dispatch('setLoginData', {
              role: ROLES.TEACHER,
              data: data
            });
            resolve(this.infoData);
          }
        });
      }));
    }
  }
  visit() {
    return new Promise((resolve, reject) => {
      this.$permission
        .isTeacher()
        .then(() => {
          resolve();
        })
        .catch(res => {
          Message.error(res.msg);
          location.href = '/';
        });
    });
  }
}
export default new Teacher();
